import * as Types from '../../../generated/webapp_gql';

import { gql } from 'graphql.macro';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
const defaultOptions =  {}
export type ProviderFragment = (
  { __typename?: 'CoachNode' }
  & Pick<Types.CoachNode, 'uuid' | 'firstName' | 'lastName' | 'avatar' | 'sex' | 'officeHours' | 'providerType' | 'providerSchedulingType' | 'maximumMemberSlots' | 'bufferTime' | 'defaultVisitDuration' | 'lateCancellationThreshold' | 'languagePreferences' | 'country' | 'introduction' | 'providerSpecialties' | 'licensedStates' | 'city' | 'state' | 'zipCode' | 'goalInterests' | 'matchScore' | 'credentials' | 'therapistModalities' | 'isInAppProvider' | 'races' | 'psychiatristSubtype'>
);

export type GetMyProvidersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMyProvidersQuery = (
  { __typename?: 'Query' }
  & { coachAssignments?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'CoachAssignmentNode' }
    & Pick<Types.CoachAssignmentNode, 'uuid' | 'active' | 'displayOnSchedule' | 'isPathwayAssignment' | 'providerDisplayType'>
    & { coach?: Types.Maybe<(
      { __typename?: 'CoachNode' }
      & ProviderFragment
    )>, conversation?: Types.Maybe<(
      { __typename?: 'ConversationNode' }
      & Pick<Types.ConversationNode, 'uuid'>
    )> }
  )>>> }
);

export const ProviderFragmentDoc = gql`
    fragment Provider on CoachNode {
  uuid
  firstName
  lastName
  avatar
  sex
  officeHours
  providerType
  providerSchedulingType
  maximumMemberSlots
  bufferTime
  defaultVisitDuration
  lateCancellationThreshold
  languagePreferences
  country
  introduction
  providerSpecialties
  licensedStates
  city
  state
  zipCode
  goalInterests
  matchScore
  credentials
  therapistModalities
  isInAppProvider
  races
  psychiatristSubtype
}
    `;
export const GetMyProvidersDocument = gql`
    query getMyProviders {
  coachAssignments {
    uuid
    active
    displayOnSchedule
    isPathwayAssignment
    providerDisplayType @client
    coach {
      ...Provider
    }
    conversation {
      uuid
    }
  }
}
    ${ProviderFragmentDoc}`;

/**
 * __useGetMyProvidersQuery__
 *
 * To run a query within a React component, call `useGetMyProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyProvidersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyProvidersQuery, GetMyProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyProvidersQuery, GetMyProvidersQueryVariables>(GetMyProvidersDocument, options);
      }
export function useGetMyProvidersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyProvidersQuery, GetMyProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyProvidersQuery, GetMyProvidersQueryVariables>(GetMyProvidersDocument, options);
        }
export type GetMyProvidersQueryHookResult = ReturnType<typeof useGetMyProvidersQuery>;
export type GetMyProvidersLazyQueryHookResult = ReturnType<typeof useGetMyProvidersLazyQuery>;
export type GetMyProvidersQueryResult = ApolloReactCommon.QueryResult<GetMyProvidersQuery, GetMyProvidersQueryVariables>;